import { Box, BoxProps, styled } from '@mui/material';

import CancelSvgIcon from '../../assets/svg/task-status/CancelSvgIcon';
import FailSvgIcon from '../../assets/svg/task-status/FailSvgIcon';
import LoadingTaskIcon from '../../assets/svg/task-status/LoadingTaskIcon';
import SuccesssSvgIcon from '../../assets/svg/task-status/SuccessSvgIcon';
import { TaskGroupStatus } from '../../types/Task';
import WarningSvgIcon from '../../assets/svg/task-status/WarningSvgIcon';
import PendingSvgIcon from '../../assets/svg/task-status/PendingSvgIcon';

interface ContainerProps {
  status: TaskGroupStatus;
}

const Container = styled(Box)<ContainerProps>`
  display: inline-flex;
  align-items: center;
  color: ${({ status, theme }) => {
    switch (status) {
      case 'partialCompleted':
        return theme.color.secondary.$100;
      case 'inProgress':
        return theme.color.primary.$100;
      case 'allCompleted':
        return theme.color.green.$100;
      case 'allFailed':
        return theme.color.highlight;
      case 'canceled':
      default:
        return 'inherit';
    }
  }};

  & .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    & > * {
      display: block;
    }
  }
`;

interface TaskStatusGroupIconProps extends BoxProps {
  status: TaskGroupStatus;
}

const TaskStatusGroupIcon: React.FC<TaskStatusGroupIconProps> = ({
  status,
  ...otherProps
}) => {
  let statusIcon;

  switch (status) {
    case 'partialCompleted':
      statusIcon = <WarningSvgIcon />;
      break;
    case 'allPending':
      statusIcon = <PendingSvgIcon />;
      break;
    case 'inProgress':
      statusIcon = <LoadingTaskIcon />;
      break;
    case 'allCompleted':
      statusIcon = <SuccesssSvgIcon />;
      break;
    case 'allFailed':
      statusIcon = <FailSvgIcon />;
      break;
    case 'canceled':
      statusIcon = <CancelSvgIcon />;
      break;
  }

  return (
    <Container status={status} {...otherProps}>
      <div className="icon-container">{statusIcon}</div>
    </Container>
  );
};

export default TaskStatusGroupIcon;
